import type { CSSProperties } from 'react';

/**
 * Gemeinsame Optik der Auswertungstabellen (Unfallauswertung, Marktauswertungen) -- zuerst in der
 * Unfallauswertung entstanden, hierher gezogen, damit alle Auswertungen gleich aussehen.
 */

/**
 * Zweizeiliger Tabellenkopf: die Gruppenzeile liegt eine Stufe dunkler als die Feldzeile, damit
 * die Hierarchie ohne Trennlinie lesbar ist. Beide Toene stammen aus dem Design-System
 * (theme/colors.ts, vdzGray 1 + 2 -- Figma-verifiziert), nicht aus geschaetzten Hex-Werten.
 */
export const HEADER_GROUP_BG = 'var(--mantine-color-vdzGray-2)';
export const HEADER_LABEL_BG = 'var(--mantine-color-vdzGray-1)';
export const TOTALS_BG = 'var(--mantine-color-vdzYellow-1)';

/**
 * Senkrechte Gruppengrenze. Sie laeuft durch Kopf, Datenzeilen UND Summenzeile -- nur so kann
 * das Auge beim Scannen einer Zahlenspalte nach oben der Gruppe folgen, zu der sie gehoert.
 * Eine Abgrenzung nur im Kopf wuerde genau dabei nicht helfen.
 */
export const GROUP_DIVIDER = '2px solid var(--mantine-color-vdzGray-3)';

/** Gruppenzeile tritt typografisch zurueck -- sie ordnet ein, sie benennt nicht die Spalte. */
export const GROUP_HEADER_TYPO: CSSProperties = {
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  fontSize: '0.7rem',
  fontWeight: 500,
  color: 'var(--mantine-color-vdzGray-7)',
  whiteSpace: 'nowrap',
};

/**
 * Zeilen-Hover (siehe reportTable.module.css, `.dataRow`): vdzGray-1 statt -0, der hellste Ton
 * unterscheidet sich mit 2 % kaum von Weiss und waere als Highlight nicht wahrnehmbar.
 */
export const ROW_BG = 'var(--mantine-color-body)';
export const ROW_BG_HOVER = 'var(--mantine-color-vdzGray-1)';

/** Gruppengrenze als Zellstil, fuer die erste Spalte einer Spaltengruppe. */
export const DIVIDER_STYLE: CSSProperties = { borderLeft: GROUP_DIVIDER };

/**
 * Zeilengrund- und Hoverfarbe als Custom Properties, umgeschaltet in reportTable.module.css
 * (`.dataRow`). Summenzeilen gelb ohne Hover; `firstSum` setzt die Gruppengrenze als obere Linie.
 */
export function rowStyle(grand: boolean, firstSum = false): CSSProperties {
  return {
    '--row-bg-base': grand ? TOTALS_BG : ROW_BG,
    '--row-bg-hover': grand ? TOTALS_BG : ROW_BG_HOVER,
    backgroundColor: 'var(--row-bg)',
    ...(firstSum ? { borderTop: GROUP_DIVIDER } : {}),
  } as CSSProperties;
}

/**
 * Karte um eine Auswertungstabelle: ohne Innenabstand, die Tabelle reicht bis an den Rand. Das
 * Theme gibt Karten 28 px oben/unten -- deshalb zusaetzlich zu `padding={0}` noetig.
 */
export const TABLE_CARD_STYLE: CSSProperties = {
  overflow: 'hidden',
  paddingTop: 0,
  paddingBottom: 0,
};
